import { MapComponent } from "../components/personal/DashboardPage/MapComponent";

export default function TestPage(){
    return(
        <>
        <div>тестовая страница</div>
        <div>
            <MapComponent/>
        </div>
        </>
    )
}